import { Carousel } from "react-bootstrap"
import { url_images } from "../../lib/backend/data"
import useIsMobile from "../../subComponents/general/isMobile"
import { FaAngleLeft, FaChevronLeft, FaChevronRight } from "react-icons/fa"

const { useSelector } = require("react-redux")

const Banners = props => {
    const {
        zone
    } = props
    const sitio = useSelector(state => state.sitio)
    const isMobile = useIsMobile()

    if(!sitio.banners) return null
    if(typeof sitio.banners !== "object") return null
    if(!sitio.banners[zone]) return null
    if(!Array.isArray(sitio.banners[zone].banners)) return null
    if(sitio.banners[zone].banners.length === 0) return null
    if(isMobile && sitio.banners[zone].hideOnMobile === true) return false

    const banners_validos = sitio.banners[zone].banners.filter(e => e.img)
    if(banners_validos.length === 0) return null
    return <div>
        <Carousel style={{ overflow: "hidden"}} 
        nextIcon={<FaChevronRight color="black" size={30} />}
        prevIcon={<FaChevronLeft color="black" size={30} />}
        >
            {banners_validos.map((e, i) => {
                if(isMobile && e.hideOnMobile === true) return null 
                if(!isMobile && e.onlyOnMobile === true) return null
                const colorText = e.mode === "dark" ? "text-dark" : "text-white"
                const maxWidth = e.maxWidth || "30%"
                const description = e.description ? <p className="mb-0">{e.description}</p> : null
                const sub_title = e.sub_title ? <h3 style={{ fontSize: isMobile ? 11 : 20 }} className="mb-0">{e.sub_title}</h3> : null
                const title = e.title ? <h1 style={{ fontSize: isMobile ? 20 : 30 }} className="mb-0">{e.title}</h1> : null
                return <Carousel.Item key={`${zone}-banner-${i}`} style={{ maxHeight: 360 }} >
                    <img
                    className="d-block w-100"
                    src={e.img}
                    alt={e.sub_title}
                    />
                    {
                        e.title || e.sub_title ? <Carousel.Caption key={`${zone}-banner-${e.title}-${i}`} className={`${colorText}`}>
                        <div style={{ textAlign: e.typeText || "center" }}>
                        <div style={{ display: "inline-block", maxWidth }}>
                        {title || null}
                        {sub_title || null}
                        {!isMobile ? description : null}
                            </div>
                        </div>
                        </Carousel.Caption> : null
                    }
                </Carousel.Item>
            })}
            </Carousel>
    </div>
}

export default Banners